import React from "react";
import { Routes, Route } from "react-router-dom";
import { hasPermission } from "../utils/permissionUtils";
import Products from "../pages/Pawn/Products/AllProduct";
import BorrowItems from "../pages/Pawn/Products/BorrowItems";
import BuyItems from "../pages/Pawn/Products/BuyItems";
import OverdueBorrowItems from "../pages/Pawn/Products/OverdueBorrowItems";
import OverduePawnItems from "../pages/Pawn/Products/OverduePawnItems";
import ReadyItems from "../pages/Pawn/Products/ReadyItems";
import SoldItems from "../pages/Pawn/Products/SoldItems";
import SellOnConsignmen from "../pages/Pawn/List/SellOnConsignmen";
import ListByCustomer from "../pages/Pawn/List/ListByCustomer";
import Bin from "../pages/Pawn/List/Bin";
import RedemptionItems from "../pages/Pawn/List/RedemptionItems";
import SettingPrice from "../pages/Pawn/List/SettingPrice";
import CustomerList from "../pages/Pawn/List/CustomerList";
import Inventory from "../pages/Pawn/Report/Inventory";
import IncomeExpenes from "../pages/Pawn/Report/IncomeExpenses";
import Interest from "../pages/Pawn/Report/Interest";
import ImportData from "../pages/Pawn/ImportRetrospectiveData/ImportData";
import ImportInformationBuy from "../pages/Pawn/ImportRetrospectiveData/ImportInformationPawn";
import ImportInformationPawn from "../pages/Pawn/ImportRetrospectiveData/ImportInformationBuy";
import ImportList from "../pages/Pawn/ImportRetrospectiveData/ImportList";
import Dashboard from "../pages/Dashboard";

const CarRoutes = ({ permissions }) => {
  return (
    <Routes>
      <Route path="/" element={<CarChildRoutes permissions={permissions} />} />
    </Routes>
  );
};

const CarChildRoutes = ({ permissions }) => {
  return (
    <Routes>
      <Route path="dashboard_car" element={<Dashboard />} />
      {hasPermission(permissions, [
        "List_Products",
        "Edit_Products",
        "Car",
      ]) && (
        <>
          <Route path="all_car" element={<Products />} />
          <Route path="buy_car" element={<BuyItems />} />
          <Route path="ready_car" element={<ReadyItems />} />
          <Route path="borrow_car" element={<BorrowItems />} />
          <Route path="overdue_borrow_car" element={<OverdueBorrowItems />} />
          <Route path="sold_car" element={<SoldItems />} />
          <Route path="overdue_pawn_car" element={<OverduePawnItems />} />
        </>
      )}

      {hasPermission(permissions, ["List1", "Edit_List1", "Car"]) && (
        <>
          <Route path="sell_on_consignmen_car" element={<SellOnConsignmen />} />
          <Route path="redemption_car" element={<RedemptionItems />} />
          <Route path="setting_price_car" element={<SettingPrice />} />
          <Route path="list_by_customer_car" element={<ListByCustomer />} />
          <Route path="bin_car" element={<Bin />} />
          <Route path="customer_list_car" element={<CustomerList />} />
        </>
      )}

      {hasPermission(permissions, ["List_Report", "Edit_Report", "Car"]) && (
        <>
          <Route path="inventory_car" element={<Inventory />} />
          <Route path="income_expenses_car" element={<IncomeExpenes />} />
          <Route path="interest_car" element={<Interest />} />
        </>
      )}

      {hasPermission(permissions, ["List_Import", "Edit_Import", "Car"]) && (
        <>
          <Route path="import_data_car" element={<ImportData />} />
          <Route
            path="import_information_car"
            element={<ImportInformationPawn />}
          />
          <Route
            path="import_information_buy_car"
            element={<ImportInformationBuy />}
          />
          <Route path="import_list_car" element={<ImportList />} />
        </>
      )}
    </Routes>
  );
};

export default CarRoutes;
